module.exports = __webpack_public_path__ + "static/media/room-back-white.56937491.svg";